import {
  MISSION_STATUS_ENUM,
  MISSION_ENUM_TYPES,
} from '../../../../shared/constants'
import { authorization } from './../../../../Module/Auth/Auth'
import { formatToLocalDate } from '../../../../shared/libraries/utils/date'
import { isDefined } from '../../../../shared/libraries/utils/object'
import { mergeWith } from 'lodash'

function getEditableFields(missionStatus, missionType) {
  return editableByRole(missionType)[missionStatus]
}

function editableByRole(missionType) {
  if (missionType === MISSION_ENUM_TYPES.LETTERBOX) {
    if (authorization.isClient()) {
      return emptyFields
    }

    if (authorization.isCityManagerAssistant()) {
      return baseFields
    }

    return merge(baseFields, payoutFields)
  }

  if (authorization.isClient()) {
    return merge(emptyFields, { [MISSION_STATUS_ENUM.DRAFT]: ['locationId'] })
  }

  if (authorization.isCityManagerAssistant()) {
    return merge(baseFields, locationFields)
  }

  return merge(baseFields, locationFields, payoutFields)
}

const emptyFields = {
  [MISSION_STATUS_ENUM.DRAFT]: [],
  [MISSION_STATUS_ENUM.AVAILABLE]: [],
  [MISSION_STATUS_ENUM.BOOKED]: [],
  [MISSION_STATUS_ENUM.COMPLETED]: [],
  [MISSION_STATUS_ENUM.CHECKED_IN]: [],
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: [],
  [MISSION_STATUS_ENUM.PAID]: [],
}

const payoutFields = {
  [MISSION_STATUS_ENUM.DRAFT]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.AVAILABLE]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.BOOKED]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.CHECKED_IN]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.COMPLETED]: ['payoutRatio', 'payoutRatioComment'],
  [MISSION_STATUS_ENUM.CANCELLED]: ['payoutRatio', 'payoutRatioComment'],
}

const locationFields = {
  [MISSION_STATUS_ENUM.DRAFT]: ['locationId'],
  [MISSION_STATUS_ENUM.AVAILABLE]: ['locationId'],
  [MISSION_STATUS_ENUM.BOOKED]: ['locationId'],
  [MISSION_STATUS_ENUM.CHECKED_IN]: [],
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: [],
  [MISSION_STATUS_ENUM.COMPLETED]: [],
  [MISSION_STATUS_ENUM.CANCELLED]: [],
  [MISSION_STATUS_ENUM.PAID]: ['flyerInventoryId'],
}

const baseFields = {
  [MISSION_STATUS_ENUM.DRAFT]: [
    'pickupTime',
    'userId',
    'draftPayAdjustment',
    'comments',
    'dateTime',
    'label',
  ],
  [MISSION_STATUS_ENUM.AVAILABLE]: [
    'userId',
    'pickupTime',
    'comments',
    'dateTime',
    'label',
    'bonusOnConversion',
    'bonusThreshold',
  ],
  [MISSION_STATUS_ENUM.BOOKED]: [
    'userId',
    'checkInTime',
    'checkoutTime',
    'flyerInventoryId',
    // Allowing this because you can set both checkIn and checkout time to
    // complete the mission
    'checkoutFlyerQuantity',
    'unbookReason',
    'comments',
    'dateTime',
    'label',
  ],
  [MISSION_STATUS_ENUM.CHECKED_IN]: [
    'checkInTime',
    'checkoutTime',
    'flyerInventoryId',
    // Allowing this because you can set both checkIn and checkout time to
    // complete the mission
    'checkoutFlyerQuantity',
    'comments',
    'label',
  ],
  [MISSION_STATUS_ENUM.UNDER_REVIEW]: [
    'checkoutFlyerQuantity',
    'checkoutTime',
    'checkInTime',
    'flyerInventoryId',
    'comments',
    'label',
  ],
  [MISSION_STATUS_ENUM.COMPLETED]: [
    'checkoutFlyerQuantity',
    'checkoutTime',
    'checkInTime',
    'flyerInventoryId',
    'comments',
    'label',
  ],
  [MISSION_STATUS_ENUM.CANCELLED]: [
    'flyerInventoryId',
    'checkoutFlyerQuantity',
    'comments',
    'label',
  ],
  [MISSION_STATUS_ENUM.PAID]: ['comments', 'label'],
}

function merge(...values) {
  return mergeWith({}, ...values, (objValue, srcValue) => {
    if (Array.isArray(objValue)) {
      return objValue.concat(srcValue)
    }
  })
}

const missionCheckinCheckoutTimeFormater = (missionTime, time) => {
  if (!time) return time

  const splitedTime = time.split(':')
  return formatToLocalDate(
    new Date(new Date(missionTime).setHours(splitedTime[0], splitedTime[1])),
  )
}

const isValidNumericValue = value => !isNaN(Number(value)) && isDefined(value)

const getTimestampAndSetTime = ({ missionDateTime, hoursStr }) => {
  const [hours, minutes] = hoursStr.split(':')
  const date = new Date(missionDateTime)
  date.setHours(Number(hours))
  date.setMinutes(Number(minutes))

  return +date
}

const convertTimeToTimestamp = date => (date ? +new Date(date) : null)

export {
  getEditableFields,
  getTimestampAndSetTime,
  convertTimeToTimestamp,
  missionCheckinCheckoutTimeFormater,
  isValidNumericValue,
}
